/**
 * @file
 * @prettier
 */

import { InitializeSurveyPages } from "./surveyPages.js";

export function InitializeSecureBorrowerSurveyLogoutSurveyPage() {
  InitializeSurveyPages();

  // set the appropriate CSS survey theme
  var surveyTheme = "surveyTheme";
  surveyTheme = surveyTheme + getCurrentQuarter();
  $("div[id$='divSurvey']").addClass(surveyTheme);
}

function getCurrentQuarter() {
  const currentDate = new Date();
  var quarter = [1, 2, 3, 4];
  return quarter[Math.floor(currentDate.getMonth() / 3)];
}
